import { useContext, useState } from 'react';
import { FormContext, FormErrorTypes } from 'dash-ui';

import { CreateUserFormFields } from 'pages/management/constants/constants';
import { DashValidation, isEmailValid, isEmptyOrNil, isNameLengthValid, isPasswordValid } from 'dash-common';
import { useTranslation } from 'react-i18next';

export const useUserFormValidation = () => {
  const { errorHandlers, formState } = useContext(FormContext);
  const [isError, setIsError] = useState(false);
  const { t } = useTranslation('forms');
  const isValueExist =
    formState.email ||
    formState.password ||
    formState.firstName ||
    formState.lastName;

  const validate = (field: CreateUserFormFields, value: string) => {
    switch (field) {
      case CreateUserFormFields.FirstName:
      case CreateUserFormFields.LastName: {
        if (isEmptyOrNil(value)) {
          setIsError(true);
          return errorHandlers[field]({
            type: FormErrorTypes.Invalid,
            message: t('messages.nameBlank'),
          });
        }
        if (!isNameLengthValid(value)) {
          setIsError(true);
          return errorHandlers[field]({
            type: FormErrorTypes.Invalid,
            message: t('forms:messages.maxCharacterLimit', {
              number: DashValidation.MaxNameLength.toString(),
            }),
          });
        }
        setIsError(false);
        errorHandlers[field](null);
        break;
      }
      case CreateUserFormFields.Email: {
        if (!isEmailValid(value)) {
          setIsError(true);
          return errorHandlers[field]({
            type: FormErrorTypes.Invalid,
            message: t('messages.emailInvalid'),
          });
        }
        setIsError(false);
        errorHandlers[field](null);
        break;
      }
      case CreateUserFormFields.Password: {
        if (!isPasswordValid(value)) {
          setIsError(true);
          return errorHandlers[field]({
            type: FormErrorTypes.Invalid,
            message: t('messages.passwordInvalid'),
          });
        }
        setIsError(false);
        errorHandlers[field](null);
        break;
      }
      default: {
        setIsError(false);
        errorHandlers[field](null);
      }
    }
  };

  return { validate, isError: isError && !isValueExist };
};
